import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { OverrideNoteDetail } from 'src/app/public/app/models/overrideNoteDetail';

@Component({
  selector: 'app-associate-candidates-actions-modal',
  templateUrl: './associate-candidates-actions-modal.component.html'
})
export class AssociateCandidatesActionsModalComponent implements OnInit {

  modalData: any;

  candidateId: any;
  candidateName: any;
  suspendedMonths: any;
  releaseDate: any;
  allowOverride: any;
  releasedJobDetails: any;
  type: any;
  modalTitle: string;
  recruiterDetails: any;

  constructor(
    private bsModalRef: BsModalRef,
    public bsModalService: BsModalService
  ) {
    if (this.bsModalService.config.initialState) {
      this.modalData = this.bsModalService.config.initialState;
    }
  }

  ngOnInit() {
    this.candidateId = this.modalData.candidateId;
    this.candidateName = this.modalData.candidateName;
    this.suspendedMonths = this.modalData.suspendedMonths;
    this.releaseDate = this.modalData.releaseDate;
    this.allowOverride = this.modalData.allowOverride;
    this.releasedJobDetails = this.modalData.releasedJobDetails;
    this.type = this.modalData.type;
    this.modalTitle = 'Override';
    this.recruiterDetails = new OverrideNoteDetail(this.candidateId);
  }

  saveCallback() {
    if (this.modalData.saveCallback) {
      this.modalData.saveCallback(this.recruiterDetails);
    }
    this.closeModal();
  }

  cancelCallback() {
    if (this.modalData.cancelCallback) {
      this.modalData.cancelCallback();
    }
    this.closeModal();
  }

  closeModal() {
    this.bsModalRef.hide();
  }
}
